var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00195 0C3.14102 0 0.00195312 3.13906 0.00195312 7V42C0.00195312 45.8609 3.14102 49 7.00195 49H42.002C45.8629 49 49.002 45.8609 49.002 42V7C49.002 3.13906 45.8629 0 42.002 0H7.00195ZM39.4973 9.1875L28.1441 22.1594L41.4988 39.8125H31.0426L22.8613 29.1047L13.4879 39.8125H8.29258L20.4332 25.9328L7.62539 9.1875H18.3441L25.7488 18.9766L34.302 9.1875H39.4973ZM35.3629 36.7062L16.7801 12.1297H13.6848L32.4754 36.7062H35.352H35.3629Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/X.4afbe6c3add3b352e8793308dc0e4a5e.svg";
export { ForwardRef as ReactComponent };